import { createColumnHelper } from '@tanstack/table-core'
import { NA } from 'constans/common'
import { useMemo } from 'react'
import { Table, Text } from 'shared/components'
import { CustomerModel } from 'types/customers'

interface CustomerInfoProps {
  data?: CustomerModel[]
}

const CustomerInfo = ({ data }: CustomerInfoProps) => {
  const columnsHelper = createColumnHelper<CustomerModel>()
  const columns = useMemo(() => {
    return [
      columnsHelper.accessor('Mobile', {
        header: 'Số điện thoại',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
      columnsHelper.accessor('TemQuantityPlus', {
        header: 'Số lượng tem đã tích',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
      columnsHelper.accessor('TemQuantityChanged', {
        header: 'Số lượng tem đã đổi',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
      columnsHelper.accessor('TemQuantityNotReceive', {
        header: 'Số lượng tem đã đổi nhưng chưa nhận quà',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
      columnsHelper.accessor('TemQuantity', {
        header: 'Số lượng tem còn lại',
        cell: row => <Text>{row.getValue() || NA}</Text>,
      }),
    ]
  }, [columnsHelper])
  return (
    <Table columns={columns} data={data || []} heading="Thông tin khách hàng" />
  )
}

export default CustomerInfo
